import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ResponseList } from '@p2p/shared/domain';
import { environment, getHttpParamsFromObject } from '@p2p/shared/utils';
import { Observable } from 'rxjs';

import { CreateUserResponse } from '../entities/create-user-response';
import { UpsertUserData } from '../entities/upsert-user';
import { User } from '../entities/user';
import { UsersPageParams } from '../state/users.model';

@Injectable({ providedIn: 'root' })
export class UsersDataService {
    private readonly http = inject(HttpClient);

    private readonly basePath = '/rest/accounts';
    private readonly listPath = `${this.basePath}/list`;
    private readonly registerPath = `${this.basePath}/register`;
    private readonly deletePath = `${this.basePath}/delete`;

    getUsers(params: UsersPageParams): Observable<ResponseList<User>> {
        return this.http.get<ResponseList<User>>(`${environment.apiUrl}${this.listPath}`, {
            params: getHttpParamsFromObject(params)
        });
    }

    getUserDetails(id: User['id']): Observable<UpsertUserData> {
        return this.http.get<UpsertUserData>(`${environment.apiUrl}${this.basePath}/${id}`);
    }

    createUser(user: UpsertUserData): Observable<CreateUserResponse> {
        return this.http.post<CreateUserResponse>(`${environment.apiUrl}${this.registerPath}`, { ...user });
    }

    editUser(user: UpsertUserData): Observable<void> {
        return this.http.put<void>(`${environment.apiUrl}${this.basePath}`, { ...user });
    }

    deleteUsers(ids: User['id'][]): Observable<unknown> {
        return this.http.patch<unknown>(`${environment.apiUrl}${this.deletePath}`, { accountIds: ids });
    }

    changeUserBlocked(id: User['id'], blocked: boolean): Observable<unknown> {
        const path = `${environment.apiUrl}${this.basePath}/${id}/${blocked ? 'unblock' : 'block'}`;

        return this.http.patch(path, {});
    }
}
